import { createContext } from "react";

export const DarkModeContext = createContext<{
  darkModeEnabled: boolean;
  toggleDarkModeEnabled: () => void;
}>({ darkModeEnabled: true, toggleDarkModeEnabled: () => {} });
